<template>
  <div class="loadingSpinner__container">
    <div class="loadingSpinner__item loadingSpinner__item--animated"></div>
  </div>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/globals/Spinner.vue